import { render } from "./JugendDialog.vue?vue&type=template&id=2c51d1cd&scoped=true"
import script from "./JugendDialog.vue?vue&type=script&lang=js"
export * from "./JugendDialog.vue?vue&type=script&lang=js"

import "./JugendDialog.vue?vue&type=style&index=0&id=2c51d1cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c51d1cd"]])

export default __exports__